module.exports = __webpack_public_path__ + "img/rsz_21rsz_1enterpreneuship_4.f3f95391.jpg";